import {
  clearAmsRedirectUrl,
  getAmsRedirectUrl,
  primaryNavOptions$,
} from '../../repositories/ams/ams.repository';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { SubscriptionManager } from '@tmx/core';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Component({
  selector: 'lib-ams-loading',
  template: `
    <div
      *transloco="let t"
      class="h-100 d-flex justify-content-center align-items-center"
    >
      <div class="text-center text-primary">
        <div class="spinner-border"></div>
        <div class="h1 text-primary mt-3">{{ t('ams.loading.loading') }}</div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule],
})
export class LoadingComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly sm = new SubscriptionManager();

  ngOnInit() {
    this.sm.manage = primaryNavOptions$
      .pipe(
        map((primaryNavOptions) => primaryNavOptions.values),
        filter((options) => options.length > 0),
        distinctUntilChanged()
      )
      .subscribe((options) => {
        const amsUrls = options.map((option) => option.url);

        const currentUrl = this.router
          .getCurrentNavigation()
          ?.initialUrl.toString();
        if (
          typeof currentUrl === 'string' &&
          amsUrls.some((amsUrl) => currentUrl.startsWith(amsUrl))
        ) {
          return;
        }

        const url = getAmsRedirectUrl();
        if (typeof url === 'string') {
          clearAmsRedirectUrl();

          if (amsUrls.some((amsUrl) => url.startsWith(amsUrl))) {
            this.router.navigateByUrl(url);
            return;
          }
        }

        this.router.navigateByUrl(options[0].url);
      });
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }
}
